{
  "nav": {
    "home": "Inicio",
    "silos": "Silos",
    "skills": "Skills",
    "arena": "Arena",
    "aiPowered": "Impulsado por IA",
    "knowledgeFlows": "El conocimiento fluye de manera inteligente a través de su organización.",
    "askTheKnowledgeBase": "Consultar la base de conocimientos",
    "ask": "Consultar",
    "help": "Ayuda",
    "logout": "Cerrar sesión",
    "signIn": "Iniciar sesión",
    "openProfileInMe": "Tu perfil en JoyIA Me"
  },
  "common": {
    "loading": "Cargando...",
    "error": "Error",
    "save": "Guardar",
    "saving": "Guardando...",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "hide": "Ocultar",
    "create": "Crear",
    "search": "Buscar",
    "filter": "Filtrar",
    "refresh": "Actualizar",
    "close": "Cerrar",
    "back": "Atrás",
    "next": "Siguiente",
    "previous": "Anterior",
    "submit": "Enviar",
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "all": "Todos",
    "none": "Ninguno",
    "select": "Seleccionar",
    "viewAll": "Ver todo",
    "remove": "Eliminar",
    "add": "Añadir",
    "new": "Nuevo",
    "success": "Éxito",
    "warning": "Advertencia",
    "info": "Información",
    "noResults": "No se encontraron resultados",
    "noData": "Gestiona tus silos de conocimiento y busca en todo el contenido",
    "clear": "Borrar",
    "sync": "Sincronizar",
    "item": "elemento",
    "items": "elementos",
    "copied": "¡Copiado!"
  },
  "silos": {
    "title": "Silos",
    "description": "Silos de conocimiento y colecciones de documentos",
    "createNew": "Crear nuevo Silo",
    "editSilo": "Editar Silo",
    "deleteSilo": "Eliminar Silo",
    "siloSettings": "Configuración del Silo",
    "knowledge": "Conocimiento",
    "project": "Proyecto",
    "timeline": "Línea de tiempo",
    "sync": "Sincronizar",
    "syncHistory": "Historial de sincronización",
    "connectors": "Conectores",
    "statusLabel": "Estado",
    "idle": "Inactivo",
    "running": "En ejecución",
    "pending": "Pendiente",
    "error": "Error",
    "newSilo": "Nuevo Silo",
    "createSilo": "Crear Silo",
    "myKnowledgeBase": "Mi base de conocimiento",
    "sortByName": "Nombre (A–Z)",
    "sortByCreated": "Creados recientemente",
    "heading": "Silos de conocimiento",
    "unitSingular": "silo",
    "searchPlaceholder": "Buscar silos...",
    "emptyTitle": "Aún no hay silos de conocimiento",
    "emptyBody": "Crea tu primer silo para empezar a construir tu base de conocimiento"
  },
  "skills": {
    "title": "Skills",
    "description": "Habilidades y capacidades",
    "createNew": "Crear nueva habilidad",
    "editSkill": "Editar habilidad",
    "deleteSkill": "Eliminar habilidad",
    "arena": "Arena",
    "skillDetails": "Detalles de habilidad",
    "knowledge": "Conocimiento",
    "project": "Proyecto",
    "mine": "Mis Skills",
    "unitSingular": "skill",
    "newSkill": "Nueva Skill",
    "searchPlaceholder": "Buscar skills…",
    "allCategories": "Todas las categorías",
    "emptyTitle": "No se han encontrado skills",
    "emptyBody": "Crea tu primera skill o importa una desde GitHub o skills.sh",
    "sharedWithTribes": "Compartidas con Tribes",
    "thisTribeHint": "Skills compartidas con esta Tribe. Abre una skill para ver las instrucciones de instalación.",
    "sharedTribesHint": "Skills compartidas con las Tribes a las que perteneces. Abre una skill para ver las instrucciones de instalación.",
    "showAllTribes": "Mostrar todas mis Tribes",
    "loadFailed": "No se pudieron cargar las skills. Recarga la página.",
    "sharedEmptyBody": "Aquí aún no se han compartido skills. Pide a un miembro del tribe que comparta uno.",
    "categoryEmptyBody": "Ningún skill coincide con la categoría «{{category}}».",
    "allSkills": "Todos los skills",
    "collections": "Colecciones de skills",
    "allSources": "Todas las fuentes",
    "source": "Fuente",
    "noMatchesBody": "Prueba otra búsqueda o elimina los filtros.",
    "clearFilters": "Eliminar filtros"
  },
  "visibility": {
    "private": "Privado",
    "privateDesc": "Solo tú puedes acceder",
    "orgVisible": "Visible para la organización",
    "orgVisibleDesc": "Cualquiera en tu organización",
    "restricted": "Restringido",
    "restrictedDesc": "Personas que invites",
    "tribe": "Tribe",
    "tribeDesc": "Todos los miembros de una tribe",
    "label": "Visibilidad",
    "public": "Público"
  },
  "classification": {
    "unclassified": "No clasificado",
    "confidential": "Confidencial",
    "strictlyConfidential": "Estrictamente confidencial"
  },
  "sources": {
    "github": "GitHub",
    "internal": "Interno",
    "skillSh": "skills.sh"
  },
  "ask": {
    "title": "Consultar",
    "askAboutThisSilo": "Consultar sobre este silo… (Intro para enviar)",
    "askAcrossAllSilos": "Consultar sobre todos los silos… (Intro para enviar)",
    "askAboutKnowledgeflow": "Consultar sobre Knowledgeflow… (Intro para enviar)",
    "askAQuestion": "Hacer una pregunta sobre esta base de conocimientos...",
    "phAsk": "Pregunta en todos los silos… (Enter para enviar, Mayús+Enter para una nueva línea)",
    "synthesised": "Las respuestas se sintetizan a partir de los silos de conocimiento a los que tienes acceso, con búsqueda basada en IA"
  },
  "settings": {
    "movedToMe": "Tu perfil ahora está en JoyIA Me. Te estamos redirigiendo…",
    "movedToMeNoUrl": "Tu perfil ahora está en JoyIA Me."
  },
  "errors": {
    "loadingFailed": "Error al cargar",
    "saveFailed": "Error al guardar",
    "deleteFailed": "Error al eliminar",
    "invalidInput": "Entrada no válida",
    "unauthorized": "No estás autorizado",
    "notFound": "No encontrado",
    "serverError": "Error del servidor",
    "failed": "Error: {{message}}"
  },
  "forms": {
    "required": "Requerido",
    "optional": "Opcional",
    "selectOne": "Selecciona uno...",
    "selectMultiple": "Selecciona varios...",
    "enterText": "Ingresa texto...",
    "enterNumber": "Ingresa un número...",
    "chooseFile": "Elegir archivo...",
    "dragDropFiles": "Arrastra y suelta archivos aquí",
    "or": "o",
    "browseFiles": "examinar archivos",
    "description": "Descripción"
  },
  "pagination": {
    "previous": "Anterior",
    "next": "Siguiente",
    "of": "de",
    "page": "Página",
    "rowsPerPage": "Filas por página"
  },
  "dialogs": {
    "confirmDelete": "Confirmar eliminación",
    "areYouSure": "¿Estás seguro de que quieres eliminar este elemento?",
    "thisCannotBeUndone": "Esta acción no se puede deshacer.",
    "deleteConfirm": "Eliminar"
  },
  "empty": {
    "noSilos": "Sin silos aún",
    "noSkills": "Sin habilidades aún",
    "noResults": "No se encontraron resultados"
  },
  "home": {
    "searchPlaceholder": "Buscar en todos los silos...",
    "noSearchResults": "No se han encontrado resultados",
    "totalItems": "Elementos totales",
    "totalMembers": "Miembros totales",
    "recentSilos": "Silos recientes",
    "noSilos": "Aún no hay silos.",
    "createOne": "Crear uno",
    "recentItems": "Elementos de conocimiento recientes",
    "knowledgeHealth": "Estado del conocimiento",
    "noItemsFromSource": "No hay elementos de esta fuente"
  },
  "siloView": {
    "abstractSaved": "Resumen guardado",
    "abstractSaveFailed": "Error al guardar resumen: {{message}}",
    "siloUpdated": "Silo actualizado",
    "siloUpdateFailed": "Error al actualizar silo: {{message}}",
    "syncFailed": "No se pudo iniciar la sincronización: {{message}}",
    "generatingAbstractBackground": "Generando resumen en segundo plano…",
    "abstractDrafted": "Resumen borrador — revisa y guarda",
    "abstractGenerateFailed": "Error al generar resumen: {{message}}",
    "editSilo": "Editar silo",
    "members": "Miembros",
    "config": "Configuración",
    "syncHistory": "Historial de sincronización",
    "treeView": "Vista de árbol",
    "mergeSilo": "Fusionar silo",
    "triggerSync": "Activar sincronización ahora",
    "syncing": "Sincronizando…",
    "abstractPlaceholder": "Escribe un breve resumen de qué contiene este silo...",
    "editAbstract": "Editar resumen",
    "regenerateWithAI": "Regenerar con IA",
    "generatingAbstract": "Generando resumen…",
    "addSummary": "+ Añade un resumen para este silo...",
    "generate": "Generar",
    "generateWithAI": "Generar resumen con IA",
    "cliSetupInstructions": "Instrucciones de configuración de CLI",
    "itemsInSilo": "{{count}} elementos en este silo",
    "cliProjectSilo": "Silo de proyecto impulsado por CLI",
    "linkSiloToProject": "Vincula este silo a un directorio de proyecto para que tus agentes IA puedan leer y escribir durante el desarrollo.",
    "step1": "1. Vincular a tu proyecto",
    "runInProjectDir": "Ejecuta esto en el directorio de tu proyecto para vincular este silo.",
    "step2": "2. Sincroniza tus archivos de proyecto",
    "syncDescription": "Ingiere el contexto de tu proyecto (README, documentos, configuración) en este silo. Idempotente — los archivos sin cambios se omiten.",
    "step3": "3. Envía una nota individual",
    "pushDescription": "Agrega un elemento. Ambos argumentos son obligatorios — o canaliza un archivo como contenido:",
    "step4": "4. Usar con agentes IA",
    "aiAgentsDescription": "Una vez vinculado, los agentes de codificación IA (Claude Code, OpenCode, etc.) pueden acceder automáticamente al conocimiento de este silo a través del servidor MCP.",
    "state_active": "Activo",
    "state_paused": "En pausa",
    "state_archived": "Archivado",
    "lastSync": "Última sincronización: {{time}}",
    "syncOverdue": "Sincronización vencida",
    "nextSync": "Próxima sincronización en {{label}}",
    "source": "Origen",
    "sortNewest": "Más recientes primero",
    "sortImportance": "Mayor importancia",
    "sortAccessed": "Más accedidos",
    "noItemsYet": "Sin elementos de conocimiento aún",
    "noItemsHelp": "Añade elementos manualmente o configura fuentes de sincronización",
    "noItemsOfType": "No se encontraron elementos {{type}}",
    "clearFilter": "Limpiar filtro",
    "mergeDialog": "Fusionar otro silo en este",
    "mergeDescription": "Todos los elementos del silo seleccionado se moverán a {{name}}.",
    "sourceSilo": "Silo de origen",
    "selectSiloMerge": "Selecciona un silo para fusionar...",
    "deleteSourceAfterMerge": "Eliminar silo de origen después de fusionar",
    "mergeSuccess": "{{count}} elementos fusionados exitosamente.{{deleted}}",
    "mergeFailed": "Error al fusionar: {{message}}",
    "merging": "Fusionando...",
    "merge": "Fusionar",
    "editSiloDialog": "Editar silo",
    "tags": "Etiquetas (separadas por coma)",
    "publicSilo": "Silo público",
    "publicSiloDescription": "Todos los usuarios de tu organización pueden leer este silo",
    "guardrailProfiles": "Perfiles de guardrail",
    "guardrailDescription": "Aplicado a todas las llamadas LLM que procesan el contenido de este silo",
    "linkToProject": "Vincular a proyecto (CLI)",
    "linkSharedSilo": "Vincular como silo compartido",
    "attachSiloDescription": "Vincula este silo a un directorio de proyecto como {{role}}, junto al silo principal del proyecto. Vinculado de solo lectura — los agentes IA pueden leerlo, pero los datos se escriben en el silo principal del proyecto.",
    "timelineSiloLabel": "un silo \"timeline\" compartido (actividad reciente)",
    "knowledgeSiloLabel": "un silo \"conocimiento\" compartido",
    "linkLimits": "Un proyecto puede vincular un silo principal más hasta 5 silos de solo lectura (uno de conocimiento, uno de timeline, más silos adicionales de solo lectura).",
    "healthAllClear": "Salud del conocimiento: todo despejado",
    "avgImportance": "Importancia promedio: {{value}}",
    "staleItem": "elemento",
    "staleItems": "elementos",
    "conflict": "conflicto",
    "multiConflicts": "conflictos",
    "archiveStale": "Archivar {{count}} vencidos",
    "archiveConfirm": "¿Archivar {{count}} elementos?",
    "runInProjectDirLabel": "Ejecutar en el directorio del proyecto",
    "staleItemsLabel": "elementos",
    "staleItemsList": "{{count}} {{type}} vencidos",
    "archivedStale": "{{count}} elementos obsoletos archivados",
    "conflicts": "{{count}} {{type}}"
  },
  "siloHealth": {
    "authExpiredTitle": "Un conector ya no puede iniciar sesión",
    "authExpiredBody": "Las credenciales guardadas de {{sources}} han caducado — normalmente porque se cambió la contraseña de la cuenta conectada. Hasta que se vuelva a conectar la fuente, ningún contenido nuevo llegará a este silo.",
    "syncFailingTitle": "Un conector no consigue sincronizar",
    "syncFailingBody": "La última sincronización de {{sources}} falló, por lo que ningún contenido nuevo está llegando a este silo.",
    "openSyncSettings": "Abrir los ajustes de sincronización",
    "unindexedTitle": "El contenido de este silo no se puede buscar",
    "thinTitle": "Solo una parte de este silo se puede buscar",
    "coverageBody": "{{indexed}} de {{total}} elementos están en el índice de búsqueda ({{pct}} %). Las preguntas dirigidas a este silo — incluidas las de cualquier sitio web vinculado — se responden solo con esa parte, y no se informa de ningún error.",
    "rebuildIndex": "Reconstruir el índice en los ajustes de sincronización"
  },
  "chart": {
    "noData": "No hay datos para mostrar",
    "fullscreen": "Pantalla completa",
    "expandedFullscreen": "Gráfico ampliado a pantalla completa",
    "closeFullscreen": "Cerrar pantalla completa"
  },
  "apps": {
    "title": "Apps y fuentes",
    "description": "Explora los elementos de conocimiento por la fuente que los creó",
    "noItems": "Aún no hay elementos de conocimiento",
    "lastUsed": "Último uso"
  },
  "skillShare": {
    "title": "Compartir Skill",
    "description": "Elige quién puede ver e instalar esta skill.",
    "visibilitySet": "Visibilidad establecida en {{value}}",
    "updateFailed": "No se ha podido actualizar la visibilidad: {{message}}",
    "selectTribes": "Selecciona las tribus que pueden ver esta skill",
    "noTribes": "No hay tribus disponibles",
    "selectAtLeastOne": "Selecciona al menos una tribu para guardar"
  },
  "skillDetail": {
    "installTracked": "Instalación registrada",
    "refreshedWithFiles": "Actualizado: {{count}} archivo{{plural}} nuevo incluido desde el origen",
    "refreshedFiles": "Actualizado desde el origen: {{count}} archivos",
    "refreshedFromSource": "Actualizado desde el origen",
    "skillDeleted": "Skill eliminada",
    "skillUpdated": "Skill actualizada",
    "share": "Share",
    "refreshing": "Refreshing…",
    "refresh": "Refresh",
    "skillNotFound": "Skill no encontrada",
    "backToSkills": "Volver a Skills",
    "public": "Public",
    "sharedWithTribe": "Compartida con el tribe",
    "private": "Private",
    "installs": "installs",
    "skillAdded": "¡Skill añadida!",
    "wantToTestInArena": "¿Quieres ver cómo se comporta en la Arena?",
    "testInArena": "Probar en la Arena",
    "editSkill": "Editar skill",
    "name": "Name",
    "version": "Version",
    "description": "Description",
    "content": "Content",
    "categories": "Categories",
    "extraTags": "Etiquetas adicionales",
    "commaSeparated": "separados por comas",
    "tagsPlaceholder": "swiftui, performance",
    "visibility": "Visibility",
    "saving": "Saving…",
    "saveChanges": "Guardar cambios",
    "pluginCapabilities": "Capacidades del plugin",
    "providesTools": "Proporciona herramientas",
    "dependencies": "Dependencies",
    "readinessCheck": "Comprobación de preparación",
    "requiredEnvironment": "Entorno necesario",
    "required": "Required",
    "nightWatchHooks": "Hooks de Night Watch",
    "notEvaluatedYet": "Todavía sin evaluar",
    "runThroughArena": "Pasa esta skill por la arena para puntuar lo bien que un modelo la sigue.",
    "runArenaTest": "Ejecutar la prueba en la arena",
    "arenaScore": "Arena Score",
    "testAgain": "Probar de nuevo",
    "evaluations": "evaluation",
    "lastTested": "última prueba",
    "hideHistory": "Ocultar el historial",
    "showAllEvaluations": "Mostrar las {{count}} evaluaciones",
    "useThisSkill": "Usar esta skill",
    "files": "files",
    "copyCommand": "Copiar el comando",
    "writesSKillMd": "Escribe SKILL.md más",
    "bundledFile": "archivo incluido",
    "copyingGivesYou": "— si copias el contenido de abajo solo obtienes SKILL.md.",
    "copySKillMd": "Copiar SKILL.md",
    "tracking": "Tracking…",
    "trackInstall": "Registrar la instalación",
    "preferredJoyiaCli": "Recomendado: CLI de Joyia",
    "setup": "Setup",
    "copy": "Copy",
    "opensInteractiveSkillBrowser": "Abre el explorador interactivo de skills. Pulsa",
    "toInstall": "para instalar.",
    "installsFromSkillsSh": "Se instala desde skills.sh; no hace falta una cuenta de Joyia.",
    "installFromJoyiaMarketplace": "Instala desde el marketplace de Joyia mediante el ID.",
    "manualInstall": "Instalación manual (sin la CLI de Joyia)",
    "install": "Install",
    "cliTab": "CLI",
    "personalTab": "Personal",
    "projectTab": "Project",
    "npxSkillsInstall": "npx skills install",
    "npxSkillsAdd": "npx skills add",
    "step1AddMarketplace": "Paso 1: añadir el marketplace",
    "step2InstallPlugin": "Paso 2: instalar el plugin",
    "copyJSON": "Copiar JSON",
    "skillContent": "Contenido de la skill",
    "copyRaw": "Copiar el texto sin formato",
    "noContent": "_No content_",
    "bundledFiles": "Archivos incluidos",
    "alongsideSKillMd": "junto a SKILL.md",
    "collapse": "Collapse",
    "expand": "Expand",
    "deleting": "Deleting…",
    "confirmDelete": "Confirmar eliminación"
  },
  "sharepoint": {
    "connected": "Conectado a Microsoft SharePoint",
    "signInFailed": "Error al iniciar sesión",
    "completingSignIn": "Completando el inicio de sesión en Microsoft…",
    "redirecting": "Conectado — redirigiendo…",
    "error": "Error al iniciar sesión",
    "backToSilos": "Volver a Silos"
  },
  "auth": {
    "subtitle": "Memoria persistente para tus agentes de IA y flujos de trabajo de desarrollo",
    "signInWithPia": "Iniciar sesión con PIA"
  },
  "askPanel": {
    "search": "Buscar",
    "ask": "Preguntar",
    "searchFailed": "La búsqueda falló",
    "failedToGetAnswer": "No se pudo obtener la respuesta",
    "semanticSearchPlaceholder": "Búsqueda semántica...",
    "focusInTree": "Enfocar en el árbol",
    "askPlaceholder": "Haz una pregunta sobre esta base de conocimientos...",
    "answer": "Respuesta",
    "sources": "Fuentes"
  },
  "skillsArena": {
    "title": "Arena de Habilidades",
    "description": "Prueba y compara habilidades — los resultados se guardan y clasifican",
    "evaluateLabel": "Evaluar una Habilidad",
    "selectSkill": "Selecciona una habilidad del catálogo o de la clasificación a continuación para evaluarla.",
    "testPromptLabel": "Prompt de Prueba",
    "testPromptPlaceholder": "Ingresa un prompt de prueba...",
    "evaluating": "Evaluando... (esto puede tomar 30-60s)",
    "evaluateButton": "Evaluar Habilidad",
    "scoreMax": "Puntuación / 100",
    "adherenceMax": "Adherencia / 10",
    "duration": "Duración",
    "criteria": "Criterios",
    "generatedOutput": "Salida Generada",
    "model": "Modelo",
    "judge": "Juez",
    "savedToRankings": "Guardado en la clasificación",
    "viewInLibrary": "Ver en la Biblioteca",
    "skillCatalog": "Catálogo de Habilidades",
    "rankings": "Clasificaciones",
    "searchCatalog": "Buscar en el catálogo...",
    "noSkillsMatch": "Ninguna habilidad coincide con tus filtros.",
    "noEvaluations": "Aún no hay evaluaciones",
    "runFirstEvaluation": "Ejecuta tu primera evaluación de Arena para comenzar a construir la clasificación.",
    "skill": "Habilidad",
    "avgScore": "Puntuación Promedio",
    "tests": "Pruebas",
    "lastRun": "Última Ejecución",
    "librarySkill": "Habilidad de Biblioteca"
  },
  "itemView": {
    "itemSaved": "Elemento guardado",
    "failedToSave": "Error al guardar",
    "memoryArchived": "Memoria archivada",
    "memoryRestoredToActive": "Memoria restaurada como activa",
    "memoryPaused": "Memoria pausada — oculta de la búsqueda",
    "failedToUpdateState": "Error al actualizar el estado",
    "itemDeleted": "Elemento eliminado",
    "failedToDelete": "Error al eliminar",
    "staleWarning": "Este elemento podría estar desactualizado — marcado como obsoleto por mantenimiento",
    "conflictDetected": "Conflicto detectado",
    "viewConflictingItem": "ver elemento conflictivo",
    "conflictResolved": "Conflicto resuelto — ambos elementos conservados",
    "keepBoth": "Mantener Ambos",
    "conflictResolvedOtherArchived": "Conflicto resuelto — otro elemento archivado",
    "keepThisArchiveOther": "Mantener Este, Archivar Otro",
    "thisItemArchived": "Este elemento ha sido archivado",
    "archiveThis": "Archivar Este",
    "tagsLabel": "Etiquetas (separadas por coma)",
    "tagsPlaceholder": "etiqueta1, etiqueta2",
    "contentLabel": "Contenido",
    "relatedMemories": "Memorias relacionadas",
    "deleteItemTitle": "¿Eliminar este elemento?",
    "deleteItemDescription": "Esto no se puede deshacer. El elemento de conocimiento y todo su contenido se eliminarán permanentemente.",
    "deleting": "Eliminando...",
    "projectLabel": "Proyecto",
    "typeLabel": "Tipo",
    "statusLabel": "Estado",
    "priorityLabel": "Prioridad",
    "assigneeLabel": "Asignado a",
    "versionLabel": "Versión",
    "summarised": "Resumido",
    "used": "Usado",
    "timesSingular": "vez",
    "timesPlural": "veces",
    "moreOptions": "Más opciones",
    "restoreToActive": "Restaurar como Activo",
    "pause": "Pausar",
    "archive": "Archivar"
  },
  "syncHistory": {
    "heading": "Historial de sincronización",
    "backToSilo": "Volver al Silo",
    "noJobs": "No hay trabajos de sincronización aún",
    "cancelled": "Sincronización cancelada — el lote actual terminará y se detendrá",
    "finalising": "Finalizando…",
    "sourcePagesTip": "Páginas de origen escaneadas — no es lo mismo que agregar elementos al silo",
    "src": "src",
    "itemsCreatedTip": "Nuevos elementos agregados al silo",
    "itemsUpdatedTip": "Elementos existentes actualizados",
    "itemsSkippedTip": "Elementos sin cambios omitidos",
    "itemsDeletedTip": "Elementos eliminados del silo",
    "stopSync": "Detener sincronización",
    "jobId": "ID del trabajo",
    "parentSync": "Sincronización principal",
    "triggeredBy": "Activado por",
    "duration": "Duración",
    "since": "Desde",
    "sinceLower": "desde",
    "items": "Elementos",
    "new": "nuevo",
    "updated": "actualizado",
    "unchanged": "sin cambios",
    "deleted": "eliminado",
    "refused": "Rechazados",
    "fileNotIndexed": "archivo no indexado",
    "files": "archivos no indexados",
    "labelled": "etiquetados",
    "error": "error",
    "errors": "errores",
    "retrying": "Reintentando…",
    "retry": "Reintentar",
    "finalisingDetail": "Finalizando — verificando que no queden más páginas, luego cerrando el trabajo…",
    "scanningSource": "Escaneando origen…",
    "sourcePages": "páginas de origen",
    "sourcePageNote": "Páginas de origen escaneadas ≠ elementos agregados. Los recuentos de elementos (+nuevo ~actualizado =sin cambios) se acumulan cuando se completa cada lote.",
    "processing": "Procesando…",
    "starting": "Iniciando… esperando el primer lote",
    "waitingForWorker": "Esperando que el worker recoja el trabajo…",
    "stoppedBy": "Detenido por {{user}} — las páginas ya ingeridas se mantienen",
    "user": "usuario"
  },
  "newSkill": {
    "skillCreated": "Habilidad \"{name}\" creada",
    "skillImported": "Importada \"{name}\"",
    "noSkillFilesFound": "No se encontraron archivos de habilidad .md en este repositorio",
    "couldNotQueryGitHub": "No se pudo consultar GitHub",
    "couldNotFetchSkill": "No se pudo obtener la habilidad de GitHub",
    "invalidRef": "Referencia no válida — use owner/repo/path/to/file.md",
    "couldNotFetchFile": "No se pudo obtener el archivo de GitHub",
    "pageTitle": "Nueva Habilidad",
    "createTab": "Crear",
    "importTab": "Importar desde GitHub",
    "nameLabel": "Nombre *",
    "namePlaceholder": "code-review",
    "versionLabel": "Versión",
    "descriptionLabel": "Descripción",
    "descriptionPlaceholder": "Descripción breve de lo que hace esta habilidad",
    "contentLabel": "Contenido *",
    "categoriesLabel": "Categorías",
    "extraTagsLabel": "Etiquetas adicionales",
    "optional": "(opcional)",
    "visibilityLabel": "Visibilidad",
    "pasteAnyOf": "Pegue uno de estos:",
    "pasteUrlPlaceholder": "Pegue una URL de GitHub o owner/repo/path…",
    "searchSpecificDirectory": "Buscar en un directorio específico",
    "customSearchPlaceholder": "p.ej. agents/ o .claude/skills",
    "readyToImport": "Listo para importar",
    "categoriesLabelImport": "Categorías",
    "optionalAddsToImportedTags": "(opcional, se agrega a las etiquetas importadas)",
    "visibilityAfterImport": "Visibilidad después de la importación",
    "importing": "Importando…",
    "importButton": "Importar Habilidad",
    "contentPlaceholder": "# Contenido de Habilidad\n\nDescribe aquí las instrucciones, indicaciones o configuración de la habilidad…",
    "creating": "Creando…",
    "createButton": "Crear Habilidad",
    "discovering": "Descubriendo…",
    "loading": "Cargando…",
    "discoverButton": "Descubrir",
    "previewButton": "Vista previa",
    "searchButton": "Buscar",
    "notFoundSpecifyPath": "¿No encontrado? Especificar ruta →",
    "importButtonLabel": "Importar Habilidad",
    "repoUrl": "URL del repositorio",
    "directFileUrl": "URL directa del archivo"
  },
  "siloTimeline": {
    "mapNotGenerated": "Mapa de Inteligencia de Plataforma aún no generado",
    "triggerSyncToBuild": "Activar una sincronización para generarlo.",
    "builtFromSnapshots": "Construido desde tus snapshots diarios — envía algunos con `joyia memory sync git-log`, o adjunta una integración del lado del servidor.",
    "platformMap": "Mapa de Inteligencia de Plataforma",
    "historicalRecord": "Registro Histórico",
    "noSnapshotsYet": "Aún no hay snapshots diarios. Activar una sincronización para comenzar a ingerir.",
    "noSnapshotsPush": "Aún no hay snapshots diarios. Envíalos desde tu proyecto con `joyia memory sync git-log`.",
    "seeded": "{{count}} elementos de cronograma inicializados",
    "seedTestData": "Inicializar datos de prueba",
    "dailySnapshots": "Snapshots Diarios",
    "windowDesc": "(ventana móvil de 30 días, los datos más antiguos se compactan en Registro Histórico)",
    "timelineExplorer": "Explorador de Cronograma",
    "updatedAgo": "Actualizado hace {{time}}",
    "noContentYet": "Sin contenido aún."
  },
  "syncConfig": {
    "dangerZone": "Zona de riesgo",
    "resetStoreTitle": "Restablecer el almacén y reiniciar",
    "resetStoreDesc": "Elimina todos los elementos importados y borra los marcadores de sincronización. Se conserva la configuración del origen. La siguiente sincronización volverá a importar todo desde cero.",
    "resetRestartBtn": "Restablecer y reiniciar",
    "areYouSure": "¿Seguro?",
    "resetting": "Restableciendo…",
    "yesReset": "Sí, restablecer",
    "rebuildIndexTitle": "Reconstruir el índice de búsqueda",
    "rebuildIndexDesc": "Reconstruye el árbol de búsqueda semántica a partir de los elementos que ya hay en este silo. No se elimina nada y no se pierde ningún contenido. Úsalo si la búsqueda no devuelve nada, o si al preguntar algo a este silo responde que «todavía no se puede buscar» mientras no hay ninguna sincronización en marcha: ese estado no se resuelve por sí solo. También conviene ejecutarlo después de una importación masiva.",
    "indexing": "Indexando…",
    "queuing": "En cola…",
    "rebuildIndexBtn": "Reconstruir el índice",
    "tokenHelp": {
      "confluence": "Crear un token de API de Atlassian",
      "jira": "Crear un token de API de Atlassian",
      "openwebui": "Crear una clave de API en chat.joyia.p7s1.io (Settings → Account)",
      "gitlab": "Crear un token de acceso personal de GitLab",
      "github": "Crear un token de acceso personal de GitHub",
      "slack": "Crear una app de Slack y un token de bot",
      "teams": "Azure Portal → App registrations → Certificates & secrets",
      "sharepoint": "Azure Portal → App registrations → Certificates & secrets",
      "gdrive": "Google Cloud Console → Service Accounts → Keys"
    },
    "heading": "Configuración de la sincronización",
    "syncHistory": "Historial de sincronizaciones",
    "addSource": "Añadir un origen",
    "addIngestSource": "Añadir un origen de importación",
    "docAndTimelineConnectors": "Conectores de documentos y cronología",
    "phBaseUrl": "URL base",
    "phApiToken": "Token de API",
    "phEmail": "Correo electrónico",
    "phGitlabUrl": "URL base de GitLab (p. ej. https://gitlab.com)",
    "phPersonalAccessToken": "Token de acceso personal",
    "phProjectPaths": "Claves o rutas de los proyectos (separadas por comas, p. ej. mygroup/myrepo)",
    "phEnvironments": "Entornos (opcionales, separados por comas, p. ej. production,staging)",
    "phDatadogApiKey": "Clave de API de Datadog",
    "createDatadogApiKey": "Crear una clave de API de Datadog ↗",
    "phDatadogAppKey": "Clave de aplicación de Datadog",
    "createDatadogAppKey": "Crear una clave de aplicación de Datadog ↗",
    "phDatadogSiteDefault": "Site (predeterminado: datadoghq.eu)",
    "phServices": "Servicios (opcionales, separados por comas)",
    "phFilterTags": "Etiquetas de filtro (opcionales, p. ej. env:production)",
    "phGithubPatPlain": "Token de acceso personal de GitHub",
    "phRepositories": "Repositorios (separados por comas, p. ej. owner/repo, owner/repo2)",
    "phPagerdutyKey": "Clave de la REST API de PagerDuty",
    "phServiceIds": "ID de los servicios (opcionales, separados por comas)",
    "phTeamIdsOptional": "ID de los equipos (opcionales, separados por comas)",
    "phBotTokenXoxb": "Token de OAuth del bot (xoxb-…)",
    "phChannelIdsLong": "ID de los canales (separados por comas, p. ej. C0123456789, C9876543210)",
    "phWorkspaceLong": "Nombre del espacio de trabajo (opcional, p. ej. Acme Engineering)",
    "phTenantId": "ID del tenant de Azure AD",
    "phClientId": "ID de cliente del registro de la aplicación",
    "phClientSecret": "Secreto de cliente",
    "phTeamIds": "ID de los equipos (separados por comas)",
    "phSiteId": "ID del site (o déjalo vacío y usa la URL del site de abajo)",
    "phSiteUrl": "URL del site (p. ej. contoso.sharepoint.com:/sites/Engineering)",
    "resourceType": "Tipo de recurso:",
    "documentLibrary": "Biblioteca de documentos",
    "sharepointList": "Lista de SharePoint",
    "phListId": "ID de la lista",
    "phDriveIdLong": "ID de la unidad (opcional: por defecto, la biblioteca de documentos del site)",
    "phFolderPathLong": "Ruta de la carpeta (opcional: subcarpeta a la que limitar la sincronización)",
    "phServiceAccountEmail": "Correo de la cuenta de servicio",
    "phPrivateKeyLong": "Clave privada (pega la clave PEM completa del JSON de la cuenta de servicio)",
    "phFolderIdsLong": "ID de las carpetas (separados por comas: comparte cada carpeta con el correo de la cuenta de servicio)",
    "entireSpaces": "Espacios completos",
    "phSpaceKeysLong": "Claves de los espacios (separadas por comas, p. ej. ENG, DOCS)",
    "importsEveryPage": "Importa todas las páginas de cada espacio indicado.",
    "pageTrees": "Árboles de páginas",
    "phPageIds": "ID de las páginas (separados por comas)",
    "phProjectKeysLong": "Claves de los proyectos (separadas por comas, p. ej. ENG, OPS)",
    "phIssueTypesLong": "Tipos de incidencia (opcionales, separados por comas, p. ej. Bug, Story)",
    "phJqlLong": "JQL personalizado (opcional: prevalece sobre las claves de los proyectos)",
    "scheduleAuto": "Programar la sincronización automática",
    "every6h": "Cada 6 h",
    "every12h": "Cada 12 h",
    "every24h": "Cada 24 h",
    "every48h": "Cada 48 h",
    "cancel": "Cancelar",
    "titleStopSync": "Detener la sincronización (el lote en curso termina y luego se detiene)",
    "titlePreviewPage": "Vista previa de la página modificada más recientemente",
    "titleDiscoverCount": "Descubrir el número real de páginas paginando Confluence",
    "extractingWithAi": "Extrayendo y resumiendo la página con IA…",
    "openInConfluence": "Abrir en Confluence ↗",
    "looksGoodStartSync": "Tiene buena pinta: inicia la sincronización completa",
    "close": "Cerrar",
    "tryAnotherPage": "Probar con otra página",
    "phSpaceKeysShort": "Claves de los espacios (separadas por comas)",
    "phProjectKeysShort": "Claves de los proyectos (separadas por comas)",
    "phIssueTypesShort": "Tipos de incidencia (opcionales)",
    "phJqlShort": "JQL personalizado (opcional)",
    "phAccessTokenKeep": "Token de acceso (déjalo vacío para conservar el actual)",
    "phApiKeyKeep": "Clave de API (déjala vacía para conservar la actual)",
    "phAppKeyKeep": "Clave de aplicación (déjala vacía para conservar la actual)",
    "phDatadogSite": "Site (p. ej. datadoghq.eu)",
    "phGithubPat": "Token de acceso personal de GitHub (déjalo vacío para conservar el actual)",
    "phRestApiKey": "Clave de la REST API (déjala vacía para conservar la actual)",
    "phBotToken": "Token de OAuth del bot (déjalo vacío para conservar el actual)",
    "phChannelIds": "ID de los canales (separados por comas)",
    "phWorkspaceShort": "Nombre del espacio de trabajo (opcional)",
    "phTenantIdKeep": "ID del tenant de Azure AD (déjalo vacío para conservar el actual)",
    "phClientIdKeep": "ID de cliente del registro de la aplicación (déjalo vacío para conservar el actual)",
    "phClientSecretKeep": "Secreto de cliente (déjalo vacío para conservar el actual)",
    "noSitesFound": "No se ha encontrado ningún site para esta conexión.",
    "phDriveIdShort": "ID de la unidad (opcional)",
    "phFolderPathShort": "Ruta de la carpeta (opcional)",
    "browseFolders": "Explorar las carpetas",
    "useThisFolder": "Usar esta carpeta",
    "loading": "Cargando…",
    "emptyFolder": "Carpeta vacía.",
    "phServiceAccountEmailKeep": "Correo de la cuenta de servicio (déjalo vacío para conservar el actual)",
    "phPrivateKeyKeep": "Clave privada (déjala vacía para conservar la actual)",
    "phFolderIdsShort": "ID de las carpetas (separados por comas)",
    "enableWebhook": "Activar la importación por webhook",
    "noIngestSources": "Todavía no hay orígenes de importación configurados",
    "addOpenwebuiOutputBtn": "Añadir una salida de OpenWebUI",
    "addOpenwebuiOutput": "Añadir una salida de OpenWebUI",
    "phOpenwebuiUrl": "URL base (p. ej. https://chat.joyia.p7s1.io)",
    "phApiKey": "Clave de API",
    "phKnowledgeBaseIds": "ID de las bases de conocimiento (uno por línea o separados por comas)",
    "addOutput": "Añadir una salida",
    "titleTriggerOutput": "Iniciar ahora la sincronización de la salida",
    "noOutputs": "Todavía no hay salidas configuradas",
    "deleteSilo": "Eliminar este silo",
    "deleteSiloBtn": "Eliminar el silo",
    "thisIsPermanent": "¡Esto es permanente!",
    "deleting": "Eliminando…",
    "testing": "Probando…",
    "testConnection": "Probar la conexión",
    "pagerDutyPath": "En tu cuenta de PagerDuty: {{path}}",
    "recommendedOwnAccount": "Recomendado: conéctate con tu propia cuenta de Microsoft (no hace falta un administrador de Azure)",
    "orAppOnly": "O configura manualmente la autenticación app-only (requiere que un administrador de Azure AD conceda acceso Sites.Selected):",
    "copyListId": "Obligatorio. Copia el ID de la lista desde SharePoint o Microsoft Graph Explorer.",
    "askToVerify": "Haz una pregunta sobre esta página para verificar que la IA la ha entendido:",
    "fetchingConfluence": "Obteniendo la página de Confluence y resumiéndola con IA…",
    "pickSiteFirst": "Elige primero un sitio arriba o introduce un ID o URL de sitio.",
    "deleteSiloWarning": "Elimina de forma permanente el silo, todos los elementos, la configuración de sincronización y los nodos del grafo de conocimiento. Esto no se puede deshacer.",
    "raptorRebuildQueued": "Reconstrucción de índice RAPTOR en cola – comprueba el Historial de sincronización para el progreso",
    "rebuildFailed": "Reconstrucción fallida: {{error}}",
    "syncCancelled": "Sincronización cancelada – el lote actual finalizará y luego se detendrá",
    "cancelFailed": "Cancelación fallida: {{error}}",
    "resetComplete": "Restablecimiento completado – {{deletedItems}} elementos eliminados, {{sourcesReset}} fuente(s) borrada(s). Activa una sincronización completa para reingerir.",
    "resetFailed": "Restablecimiento fallido: {{error}}",
    "syncFailed": "Sincronización fallida: {{error}}",
    "outputSyncQueued": "Sincronización de salida en cola",
    "outputSyncFailed": "Sincronización de salida fallida: {{error}}",
    "sourceAdded": "Fuente añadida",
    "failedToAddSource": "Error al añadir la fuente: {{error}}",
    "sourceRemoved": "Fuente eliminada",
    "failedToRemoveSource": "Error al eliminar la fuente: {{error}}",
    "sourceUpdated": "Fuente actualizada",
    "failedToUpdateSource": "Error al actualizar la fuente: {{error}}",
    "enterBaseUrlAndApiKeyFirst": "Por favor, introduce primero la URL base y la clave API.",
    "connectedFoundKbsWithNames": "¡Conectado! {{count}} base(s) de conocimiento encontrada(s): {{names}}",
    "connectedFoundKbs": "¡Conectado! {{count}} base(s) de conocimiento encontrada(s).",
    "connectionFailed": "Conexión fallida: {{error}}",
    "outputAdded": "Salida añadida",
    "failedToAddOutput": "Error al añadir la salida: {{error}}",
    "outputRemoved": "Salida eliminada",
    "failedToRemoveOutput": "Error al eliminar la salida: {{error}}",
    "discoverFailed": "Descubrimiento fallido: {{error}}",
    "previewFailed": "Vista previa fallida: {{error}}",
    "askFailed": "Consulta fallida: {{error}}",
    "descSpaces": "espacios: {{keys}}",
    "descProjects": "proyectos: {{keys}}",
    "descJql": "JQL: {{jql}}…",
    "descServices": "servicios: {{services}}",
    "descRepos": "repositorios: {{repos}}",
    "descTeams": "equipos: {{teams}}",
    "descChannels": "canales: {{channels}}",
    "descSyncedViaCli": "Sincronizado a través de Joyia CLI (joyia memory sync)",
    "descList": "lista: {{listId}}",
    "descListNoId": "lista (sin ID de lista establecido)",
    "descFolder": "carpeta: {{folderPath}}",
    "descNoSiteConfigured": "Ningún sitio configurado",
    "descFolders": "carpetas: {{folders}}",
    "descNoFoldersConfigured": "Ninguna carpeta configurada",
    "descNoUrlConfigured": "Ninguna URL configurada",
    "disableScheduledSync": "Desactivar sincronización programada",
    "enableScheduledSync": "Activar sincronización programada",
    "schedule": "programación",
    "cancelEdit": "Cancelar edición",
    "editSource": "Editar fuente",
    "incrementalSyncTitle": "Sincronización incremental (solo cambios)",
    "fullSyncTitle": "Sincronización completa",
    "syncAlreadyRunning": "Sincronización ya en curso",
    "forceFullResync": "Forzar resincronización completa (todas las páginas)",
    "rawExcerptAiUnavailable": "Extracto sin procesar (IA no disponible)",
    "aiSummary": "Resumen de IA",
    "phAskPageQuestion": "p. ej. ¿Cuál es el tema principal de esta página?",
    "webhookUrlCopied": "URL de webhook copiada",
    "copy": "Copiar",
    "yesDelete": "Sí, eliminar"
  },
  "connector": {
    "confluenceDesc": "Páginas y espacios",
    "jiraDesc": "Incidencias y proyectos",
    "openwebuiDesc": "Base de conocimiento",
    "gitlabDesc": "Pipelines, merge requests y despliegues",
    "datadogDesc": "Monitores y eventos",
    "githubDesc": "Actions, pull requests y releases",
    "pagerdutyDesc": "Incidentes y guardias",
    "slackDesc": "Resúmenes de canales y debates",
    "teamsDesc": "Actividad de los canales",
    "local": "Local / CLI",
    "localDesc": "Archivos del proyecto mediante la CLI de joyia",
    "sharepointDesc": "Bibliotecas de documentos",
    "gdriveDesc": "Docs, Sheets y Slides",
    "confluence": "Confluence",
    "jira": "Jira",
    "openwebui": "OpenWebUI",
    "gitlab": "GitLab",
    "datadog": "Datadog",
    "github": "GitHub",
    "pagerduty": "PagerDuty",
    "slack": "Slack",
    "teams": "MS Teams",
    "sharepoint": "SharePoint",
    "gdrive": "Google Drive"
  },
  "siloTree": {
    "syncing": "Sincronizando…",
    "treeStats": "Estadísticas del árbol",
    "totalNodes": "Nodos totales",
    "layers": "Capas",
    "leafNodes": "Nodos hoja",
    "summaries": "Resúmenes",
    "legend": "Leyenda",
    "leafChunk": "Fragmento hoja",
    "treeExplorer": "Explorador del árbol",
    "loadingTree": "Cargando el árbol…",
    "failedToLoad": "No se pudo cargar el árbol",
    "retry": "Reintentar",
    "noTreeYet": "Todavía no se ha construido ningún árbol RAPTOR",
    "triggerSync": "Inicia una sincronización para construir el índice semántico.",
    "goToSilo": "Ir al silo",
    "summarisedFrom_one": "Resumido a partir de {{count}} nodo",
    "summarisedFrom_other": "Resumido a partir de {{count}} nodos"
  },
  "createItem": {
    "addItem": "Añadir un elemento de conocimiento",
    "title": "Título *",
    "phTitle": "Título del elemento",
    "content": "Contenido",
    "phContent": "Se admite Markdown…",
    "knowledgeType": "Tipo de conocimiento",
    "typeAuto": "Detección automática",
    "typeFactual": "Factual: documentos de referencia, hechos estables",
    "typeProcedural": "Procedimental: runbooks, guías prácticas",
    "typeTemporal": "Temporal: eventos acotados en el tiempo, instantáneas",
    "typeRelational": "Relacional: dependencias, arquitectura",
    "typeContextual": "Contextual: estado actual, incidentes",
    "typeSocial": "Social: estructura del equipo, responsabilidades",
    "typePolicy": "Normativo: cumplimiento, SLA, gobernanza",
    "typeMeta": "Meta: resúmenes, índices",
    "tags": "Etiquetas (separadas por comas)",
    "suggestTags": "Sugerir etiquetas con IA a partir del título y el contenido"
  },
  "createSilo": {
    "startingLayout": "Estructura inicial",
    "change": "Cambiar",
    "tags": "Etiquetas (separadas por comas)",
    "publicSilo": "Silo público",
    "publicSiloDesc": "Todas las personas de tu organización pueden leer este silo",
    "guardrailProfiles": "Perfiles de protección",
    "guardrailDesc": "Se aplica a todas las llamadas al LLM que procesan el contenido de este silo",
    "cancel": "Cancelar",
    "creating": "Creando…",
    "create": "Crear silo"
  },
  "errorBoundary": {
    "somethingWrong": "Algo ha ido mal",
    "unexpected": "Se ha producido un error inesperado",
    "tryAgain": "Inténtalo de nuevo",
    "goHome": "Ir al inicio"
  },
  "siloShare": {
    "private": "Privado",
    "privateDesc": "Solo tú puedes acceder",
    "restricted": "Restringido",
    "restrictedDesc": "Las personas a las que invites",
    "tribe": "Tribe",
    "tribeDesc": "Todos los miembros de un tribe",
    "orgVisible": "Visible para la organización",
    "orgVisibleDesc": "Cualquier persona de tu organización",
    "shareSilo": "Compartir el silo",
    "controlAccess": "Decide quién puede acceder a este silo de conocimiento.",
    "visibility": "Visibilidad",
    "selectTribes": "Elige los tribes que pueden ver este silo",
    "noTribes": "No hay tribes disponibles",
    "selectAtLeastOne": "Elige al menos un tribe para guardar",
    "pendingRequests": "Solicitudes pendientes",
    "approve": "Aprobar",
    "deny": "Denegar",
    "peopleWithAccess": "Personas con acceso",
    "emailAddress": "Dirección de correo",
    "roleViewer": "Lectura",
    "roleEditor": "Edición",
    "invite": "Invitar",
    "youOwner": "Tú (propietario)",
    "owner": "Propietario",
    "removeMember": "Quitar al miembro",
    "noMembers": "Todavía no hay más miembros. Invita a alguien arriba."
  },
  "globalChat": {
    "suggestConnectSource": "¿Cómo conecto un origen?",
    "suggestSiloVsSkill": "¿Qué diferencia hay entre un silo y una skill?",
    "askAi": "Preguntar a la IA",
    "askKnowledgeBase": "Pregunta a tu base de conocimiento",
    "liveAccess": "Acceso en vivo:",
    "askAboutKf": "Preguntar sobre Knowledgeflow",
    "verifyBeforeActing": "Las respuestas salen de la documentación: verifícalas siempre antes de actuar.",
    "closeChat": "Cerrar el chat",
    "phAskKf": "Pregunta algo sobre Knowledgeflow… (Enter para enviar)",
    "clearConversation": "Borrar la conversación",
    "yourKnowledge": "Tu conocimiento",
    "help": "Ayuda",
    "thisSilo": "Este silo",
    "allSilos": "Todos los silos",
    "searchingWithinThisSilo": "Buscando dentro de este silo",
    "searchingAcrossAllSilos": "Buscando en todos los silos",
    "suggestMonitorsAlerting": "¿Qué monitores están activos?",
    "suggestRecentEvents": "Mostrar eventos recientes",
    "suggestOpenMergeRequests": "Mostrar solicitudes de combinación abiertas",
    "suggestRecentPipelineStatus": "Estado reciente del pipeline",
    "suggestIssuesInProgress": "¿Qué problemas están en curso?",
    "suggestTopicsCovered": "¿Qué temas se cubren?",
    "suggestFindRecentItems": "Encontrar elementos recientes",
    "suggestSummarizeSilo": "Resumir este silo",
    "phAskAllSilos": "Pregunta en todos los silos… (Intro para enviar)",
    "contentPolicies": "Políticas de contenido",
    "contentPoliciesActive": "Políticas de contenido (activas)",
    "answerFromDocs": "Respondo desde la documentación de Knowledgeflow."
  },
  "bundledFiles": {
    "heading": "Archivos incluidos",
    "phContents": "Contenido del archivo…"
  },
  "skillCard": {
    "viewSkill": "Ver la skill"
  },
  "carousel": {
    "prevSlide": "Diapositiva anterior",
    "nextSlide": "Diapositiva siguiente"
  },
  "agentElement": {
    "maxTurns": "Turnos máx."
  },
  "collab": {
    "settings": "Ajustes de Collab",
    "approvalMode": "Modo de aprobación",
    "maxTurnsPerPersona": "Turnos máximos por persona",
    "resetCounter": "Restablecer el contador de turnos",
    "reset": "Restablecer"
  },
  "connectionStatus": {
    "offline": "Sin conexión. Las cifras no se pueden actualizar hasta que vuelvas a estar en línea.",
    "reload": "Recargar"
  },
  "helpAnswer": {
    "sources": "Fuentes"
  },
  "helpWidget": {
    "clearAria": "Borrar la conversación",
    "clear": "Borrar la conversación",
    "closeAria": "Cerrar la ayuda",
    "reading": "Leyendo la documentación…",
    "verifyNote": "Las respuestas vienen de la documentación: verifica siempre antes de actuar.",
    "productHelp": "Ayuda {{product}}",
    "productHelpDrag": "Ayuda {{product}} — arrastra para mover",
    "answersFromDocs": "Respuestas de la documentación {{product}}",
    "askAbout": "Preguntas sobre {{product}}",
    "askAboutDetail": "Respondo desde la documentación {{product}} y puedo señalarte el lugar adecuado.",
    "askAboutPlaceholder": "Preguntas sobre {{product}}…",
    "notAvailableYet": "La ayuda aún no está disponible aquí.",
    "somethingWentWrong": "Algo salió mal (HTTP {{status}}).",
    "requestFailed": "La solicitud falló.",
    "couldNotRunAction": "No se pudo {{action}}."
  },
  "citation": {
    "prevAria": "Anterior",
    "nextAria": "Siguiente"
  },
  "installPrompt": {
    "notNowAria": "Ahora no",
    "iosPath": "Share → Add to Home Screen",
    "showMeHow": "Muéstrame cómo",
    "install": "Instalar"
  },
  "messageEditor": {
    "cancel": "Cancelar"
  },
  "message": {
    "copy": "Copiar el mensaje",
    "regenerate": "Regenerar la respuesta",
    "edit": "Editar el mensaje",
    "goodResponse": "Buena respuesta",
    "poorResponse": "Respuesta pobre"
  },
  "plan": {
    "toggle": "Mostrar u ocultar el plan"
  },
  "promptInput": {
    "removeAttachment": "Quitar el adjunto"
  },
  "reasoning": {
    "thinking": "Pensando…",
    "thoughtFor": "Ha pensado unos segundos",
    "thoughtForSeconds_one": "Ha pensado {{count}} segundo",
    "thoughtForSeconds_other": "Ha pensado {{count}} segundos"
  },
  "tool": {
    "streaming": "Transmitiendo",
    "running": "En ejecución",
    "approvalRequired": "Requiere aprobación",
    "approved": "Aprobado",
    "completed": "Completado",
    "denied": "Rechazado",
    "error": "Error",
    "pending": "Pendiente"
  }
}
